import { NavBar } from "@/components/NavBar"
import './MGuide.scss'
import { useRecoilValue } from "recoil"
import { activityInfoState } from "@/App"
import BlankPage from "@/components/Error/blank"



export const MobileGuide = () => {

  const info = useRecoilValue(activityInfoState)

  if (info.remark.length === 0) {
    return <BlankPage />
  }

  return (
    <div className="mobile-guide">
      <NavBar backTitle="返回答题"
        title={require('../../assets/img/m-guide-title.png')}
        titleStyle={{ width: '1.69rem', height: '0.46rem' }}
      />
      <div className="mobile-guide-text">{info.remark}</div>
    </div>
  )

}

